const footerYear = document.querySelector('.footer_year');
const currentYear = new Date().getFullYear();

footerYear.innerText = `@${currentYear} Berlin - Germany`;
